import React, { useMemo, useState } from "react";
import { Pressable, Text, View } from "react-native";
import AIExhibitNarrationPressable from "../audio/AIExhibitNarrationPressable";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const NARRATION_BY_CATEGORY_ID = Object.freeze({
  education: "people_society_education",
  work: "people_society_work",
  science: "people_society_science",
  creativity: "people_society_creativity",
  society: "people_society_society",
});
import { getAIExhibitBatch4Copy } from "../content/aiExhibitBatch4Content";

export default function PeopleSocietyScreen({
  language="en",
  audioEnabled=false,
}){
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  const t=getAIExhibitBatch4Copy(language).people;
  const [id,setId]=useState(t.categories[0].id);
  const c=useMemo(()=>t.categories.find(x=>x.id===id)||t.categories[0],[id,t.categories]);
  return <View style={{padding:28}}>
    <Text style={{color:C.accent,fontSize:13,fontWeight:"900",letterSpacing:1.2}}>{t.eyebrow}</Text>
    <Text style={{color:C.text,fontSize:44,lineHeight:50,fontWeight:"900",marginTop:8}}>{t.title}</Text>
    <Text style={{color:C.muted,fontSize:18,lineHeight:27,marginTop:8,maxWidth:980}}>{t.subtitle}</Text>
    <View style={{flexDirection:"row",flexWrap:"wrap",gap:10,marginTop:22}}>{t.categories.map(x=>{const active=x.id===id;return <Pressable key={x.id} onPress={()=>{
      setId(x.id);
      playNarration(NARRATION_BY_CATEGORY_ID[x.id]);
    }} style={({pressed})=>({flex:1,minWidth:170,minHeight:80,padding:14,borderRadius:15,borderWidth:active?2:1,borderColor:active?C.accent:C.border,backgroundColor:active||pressed?C.accentSoft:C.surfaceRaised,flexDirection:"row",alignItems:"center",gap:9})}><Text style={{fontSize:25}}>{x.icon}</Text><Text style={{color:C.text,fontSize:16,fontWeight:"900"}}>{x.title}</Text></Pressable>})}</View>
    <View style={{flexDirection:"row",flexWrap:"wrap",gap:16,marginTop:18}}>
      <View style={{flex:1,minWidth:340,padding:22,borderRadius:18,borderWidth:1,borderColor:C.success,backgroundColor:C.surfaceRaised}}><Text style={{color:C.success,fontSize:13,fontWeight:"900"}}>{t.opportunity.toUpperCase()}</Text><Text style={{color:C.text,fontSize:18,lineHeight:29,marginTop:10}}>{c.opportunity}</Text></View>
      <View style={{flex:1,minWidth:340,padding:22,borderRadius:18,borderWidth:1,borderColor:C.warning,backgroundColor:C.surfaceRaised}}><Text style={{color:C.warning,fontSize:13,fontWeight:"900"}}>{t.risk.toUpperCase()}</Text><Text style={{color:C.text,fontSize:18,lineHeight:29,marginTop:10}}>{c.risk}</Text></View>
    </View>
    <AIExhibitNarrationPressable
      audioEnabled={audioEnabled}
      onPress={() => playNarration("people_society_nist_risk_frame")}
      style={{marginTop:18,padding:18,borderRadius:16,borderLeftWidth:5,borderWidth:1,borderColor:C.border,borderLeftColor:C.accent,backgroundColor:C.accentSoft}}
    ><Text style={{color:C.text,fontSize:17,lineHeight:27,fontWeight:"800"}}>{t.nist}</Text><Text style={{color:C.muted,fontSize:12,marginTop:10}}>{t.source}</Text></AIExhibitNarrationPressable>
  </View>;
}
